function cov_2anpiq8dkk() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp.tsx";
  var hash = "e364c9ca0cb7989854c207ae2332468707d51df0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 50
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e364c9ca0cb7989854c207ae2332468707d51df0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2anpiq8dkk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2anpiq8dkk();
var Icon = (cov_2anpiq8dkk().s[0]++, {
  name: 'chevron-up',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.21918 16.4761C4.6801 16.0448 4.5927 15.2582 5.02396 14.7191L11.024 7.21915C11.2612 6.92263 11.6203 6.75001 12 6.75001C12.3798 6.75001 12.7389 6.92263 12.9761 7.21915L18.9761 14.7191C19.4074 15.2582 19.32 16.0448 18.7809 16.4761C18.2418 16.9074 17.4552 16.82 17.024 16.2809L12 10.001L6.97613 16.2809C6.54487 16.82 5.75825 16.9074 5.21918 16.4761Z\" fill=\"currentColor\"/>"
});
export default Icon;